import { SettingItem } from './index.d';


export const settingList: SettingItem[] = [
  {
    type: 1,
    title: '自定义安全守护',
    desc: '家长可自行设置守护区域'
  },
  {
    type: 2,
    title: '智能安全守护',
    desc: '系统智能识别特殊地点'
  }
]